import { Transporter } from 'models/transporter.model';
import { ITransporterGroup, TransporterGroup } from './transporter-group.model';
import { Civility } from './enums/civility.enum';

export interface ITransporterMember {
  id?: number;
  civility?: Civility | null;
  firstName?: string | null;
  lastName?: string | null;
  positionHeld?: string | null;
  mail?: string | null;
  phone?: string | null;
  picture?: string | null;
  description?: string | null;
  transporter?: Transporter;
  transporterGroups?: ITransporterGroup[];
}

export class TransporterMember implements ITransporterMember {
  constructor(
    public id?: number,
    public civility?: Civility | null,
    public firstName?: string | null,
    public lastName?: string | null,
    public positionHeld?: string | null,
    public mail?: string | null,
    public phone?: string | null,
    public picture?: string | null,
    public description?: string | null,
    public transporter?: Transporter,
    public transporterGroups?: TransporterGroup[]
  ) {}
}

export function getCommercialIdentifier(commercial: ITransporterMember): number | undefined {
  return commercial.id;
}
